export const blockIconsBusinessandpaymentsWorkNew = (
	<span className='material-symbols-outlined'>work</span>
);
